/** Shop/agent cost is stored as a decimal rate (e.g. 0.05 = 5%). */
export function formatCostRate(raw: string | number | undefined | null): string {
  const n = raw === undefined || raw === null ? 0 : Number(raw);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(n);
}

export function percentInputToRate(percentStr: string): number {
  const pct = parseFloat(percentStr);
  if (!Number.isFinite(pct)) return 0;
  const clamped = Math.min(100, Math.max(0, pct));
  return clamped / 100;
}
